import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {SearchParams, UserSearch} from '@models/search';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {TrackingService} from '@services/tracking.service';
import {LoginFormComponent} from '@components/popup/login-form/login-form.component';
import {OnboardingService} from '@services/onboarding.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

    alertForm = new UntypedFormGroup({
        frequency_alert: new UntypedFormControl(''),
        price_alert: new UntypedFormControl(''),
    });
    currentSearch: UserSearch;
    searchParams: SearchParams;
    loading = false;

    constructor(
        private adService: AdService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        public onboardingService: OnboardingService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AlertComponent>,
        public authenticationService: AuthenticationService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.currentSearch = this.data.userSearch;
        this.loadSearch();
    }

    onNoClick(): void {
        this.onboardingService.endAlert();
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.alertForm.valid && this.loading == false) {
            this.loading = true;
            this.currentSearch.frequency_alert = this.alertForm.get('frequency_alert').value;
            this.currentSearch.price_alert = this.alertForm.get('price_alert').value;
            this.adService.editUserSearchAlert(this.currentSearch).subscribe((us) => {
                this.onboardingService.endAlert();
                this.dialogRef.close({currentSearch: us});
            }, error => {
                this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                console.log(error);
                this.loading = false
            });
        }
    }

    loadSearch() {
        if (this.currentSearch) {
            this.alertForm = new UntypedFormGroup({
                frequency_alert: new UntypedFormControl(this.currentSearch.frequency_alert),
                price_alert: new UntypedFormControl(this.currentSearch.price_alert),
            });
        }
    }

    upgradePlan(visuel = '', feature, plan) {
        if (!this.authenticationService.isAllowed('essentiel')) {
            this.dialogRef.close(false);
            this.trackingService.click('search_result_save_alerte_upgrade_plan', feature);
            if (!this.authenticationService.isLogin) {
                const dialogRef = this.dialog.open(LoginFormComponent, {
                    width: '550px',
                    data: {
                        disableClose: false
                    },
                });
            } else {
                const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                    width: '520px',
                    data: {visuel, plan, feature}
                });
            }
        }
    }
}
